import React, { Component } from 'react';
import Footer from '../components/Principal/Footer';
import Header from '../components/Principal/Header';
import Seccion1 from '../components/Seguros/Seccion1';
import MensajeF from '../components/Mensaje_Flotante/MensajeF';
import Seccion2 from '../components/Seguros/Seccion2';

class Seguros extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    render() {
        return (
            <React.Fragment>
                <Header id={2} />
                <Seccion1 />
                <MensajeF />
                <Seccion2 />
                <Footer />
            </React.Fragment>
        );
    }
}

export default Seguros;